var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackhorns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 484.39 80.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.78,284.54s-37.41-26.05-23.6-80.05l77.72,40S215.55,287.59,172.78,284.54Z",
    transform: "translate(-146.12 -204.49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-69,119.5",
    transform: "translate(-146.12 -204.49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600,283.72s39.06-23.51,28.87-78.31l-80.21,34.77S557.07,283.91,600,283.72Z",
    transform: "translate(-146.12 -204.49)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackhorns);
export default __webpack_public_path__ + "static/media/black horns.5c29883b.svg";
export { ForwardRef as ReactComponent };